import { render } from "./timer-count-down.vue?vue&type=template&id=142f665c&scoped=true&ts=true"
import script from "./timer-count-down.vue?vue&type=script&lang=ts"
export * from "./timer-count-down.vue?vue&type=script&lang=ts"

import "./timer-count-down.vue?vue&type=style&index=0&id=142f665c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142f665c"]])

export default __exports__